import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem, FormControl, InputLabel, InputAdornment } from '@mui/material';
import { Backdrop, CircularProgress } from '@mui/material';
import { parseColombianMoneyInput } from '../../../utils/money';
import { sessionRequestConfig } from '../../../utils/csrf';
import { getApiErrorMessage } from '../../../utils/apiErrorMessage';

const API_URL = process.env.REACT_APP_API_URL;

async function actualizarReporteDiario(valor, tipo) {
  const hoy = new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Bogota' });
  try {
      const response = await axios.get(`${API_URL}/reporte_diario_cajas/`);
      const reportes = await response.data, reporteHoy = reportes.find(r => r.fecha === hoy && r.tipo === tipo);

      if (reporteHoy) {
          const nuevoValor = parseFloat(reporteHoy.valor) + Number(valor);
          await axios.put(`${API_URL}/reporte_diario_cajas/${reporteHoy.id}/`, { valor: nuevoValor } );
      } else {
          await axios.post(`${API_URL}/reporte_diario_cajas/`, { fecha: hoy, valor: Number(valor), tipo: tipo });
      }
  } catch (error) {
      console.error("Error en la actualización del reporte:", error);
  }
}

function DialogCreateMovimiento({ dialogOpen, handleDialogClose, currentCaja, onMovementSuccess }) {
  const [tipo, setTipo] = useState('');
  const [monto, setMonto] = useState('');
  const [observacion, setObservacion] = useState('');
  const [error, setError] = useState({ tipo: '', monto: '', observacion: '' });
  const [loading, setLoading] = useState(false);
  const submitRef = useRef(false);

  const handleGuardar = async () => {
    if (submitRef.current || loading) return;

    let errores = {};
    if (!tipo) errores.tipo = 'Debe seleccionar el tipo de movimiento.';
    if (!monto) errores.monto = 'Debe ingresar el monto.';
    if (!observacion) errores.observacion = 'Debe ingresar una observación.';

    if (Object.keys(errores).length > 0) {
      setError(errores);
      return;
    }

    submitRef.current = true;
    setLoading(true);

    try {
      const canonicalAmount = parseColombianMoneyInput(monto);
      await axios.post(
        `${API_URL}/movimiento/`,
        {
          caja_id: currentCaja,
          movimiento: { tipo, monto: canonicalAmount, observacion, isME: 'no' },
        },
        sessionRequestConfig()
      );

      await actualizarReporteDiario(canonicalAmount, tipo === 'Ingreso' ? 'ingreso' : 'egreso')

      await onMovementSuccess?.();
      handleClose();
    } catch (error) {
      console.error(error)
      setError({
        general: getApiErrorMessage(
          error,
          'No fue posible guardar el movimiento.'
        ),
      });
    } finally {
      submitRef.current = false;
      setLoading(false);
    }
  };

  const handleClose = () => {
    setTipo('');
    setMonto('');
    setObservacion('');
    setError({ tipo: '', monto: '', observacion: '' });
    handleDialogClose();
  };

  return (
    <Dialog open={dialogOpen} onClose={handleClose}>
      <Backdrop
        open={loading}
        style={{ zIndex: 9999, color: '#fff' }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <DialogTitle>Agregar Movimiento</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal" error={!!error.tipo}>
          <InputLabel>Tipo</InputLabel>
          <Select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            fullWidth
          >
            <MenuItem value="Ingreso">Ingreso</MenuItem>
            <MenuItem value="Egreso">Egreso</MenuItem>
          </Select>
          {error.tipo && <Typography color="error">{error.tipo}</Typography>}
        </FormControl>
        <TextField
          margin="normal"
          label="Monto"
          type="text"
          inputMode="decimal"
          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, maxLength: 10 }} 
          fullWidth
          value={monto}
          onChange={(e) => setMonto(e.target.value)}
          error={!!error.monto}
          helperText={error.monto}
        />
        <TextField
          margin="normal"
          label="Observación"
          multiline
          fullWidth
          value={observacion}
          onChange={(e) => setObservacion(e.target.value)}
          error={!!error.observacion}
          helperText={error.observacion}
        />
        {error.general && <Typography color="error">{error.general}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} color="error">
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleGuardar} color="primary" disabled={loading}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogCreateMovimiento;
